import { Box3, Object3D, PerspectiveCamera, Vector3 } from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls'

import { ModelControls } from './ModelControls'

export function fitCameraToObject(
  camera: PerspectiveCamera,
  controls: ModelControls | OrbitControls,
  object: Object3D,
  fitOffset = 1.2,
) {
  const box = new Box3().setFromObject(object)

  const size = box.getSize(new Vector3())
  const center = box.getCenter(new Vector3())

  const maxSize = Math.max(size.x, size.y, size.z)
  const fitHeightDistance = maxSize / (2 * Math.atan((Math.PI * camera.fov) / 360))
  const fitWidthDistance = fitHeightDistance / camera.aspect
  const distance = fitOffset * Math.max(fitHeightDistance, fitWidthDistance)

  const direction = controls.target
    .clone()
    .sub(camera.position)
    .normalize()
    .multiplyScalar(distance)

  controls.target.copy(center)
  camera.position.copy(controls.target).sub(direction)

  controls.update()
  return distance
}
